import { LabelProps } from './label.type'

import styles from './label.module.css'

const Label = ({ children, className, required, ...props }: LabelProps) => {
  return (
    <label className={`${styles.core} ${className || ''}`} {...props}>
      {children}
      {required && <span className={styles.required}>*</span>}
    </label>
  )
}

export default Label
